<template>
  <v-sheet
    class="
      home-section
      d-flex
      align-start align-lg-center
      justify-center
      flex-column
    "
    color="transparent"
  >
    <v-sheet color="transparent" class="home-section-social pt-0 pt-lg-8">
      <v-container class="justify-end d-flex px-lg-0">
        <v-btn
          target="_blank"
          v-for="({ icon, size, link }, i) in social"
          :key="i"
          :href="link"
          :height="!xsOnly ? `48px` : `35px`"
          :width="!xsOnly ? `48px` : `35px`"
          class="gradiente-bg ml-3"
          fab
        >
          <Icon :icon="icon" :width="size" color="#171717" />
        </v-btn>
      </v-container>
    </v-sheet>
    <v-sheet class="home-section-content" color="transparent">
      <v-container>
        <v-row align="center" justify="space-between">
          <v-col class="" cols="12" lg="7">
            <v-row align="center" justify="center" no-gutters>
              <v-col cols="5" lg="8">
                <img
                  width="100%"
                  class="d-block"
                  :src="files + informations.img"
                  :alt="informations.name"
                />
              </v-col>
            </v-row>
            <div
              class="
                about-content
                ck-content
                text-center
                white--text
                mt-6
                font-weight-bold
                text-lg-h5 text-sm-h6 text-body-1
              "
              v-html="about.text"
            ></div>
          </v-col>
          <v-col v-if="!mdAndDown" class="px-0 d-lg-block" cols="12" lg="4">
            <div
              class="
                d-flex
                justify-center
                text-h6 text-sm-h5
                font-weight-bold
                text-uppercase
                white--text
                mb-4
              "
            >
              Entre em contato:
            </div>
            <ContactForm solo />
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
    <v-sheet class="py-5" v-if="mdAndDown" width="100%">
      <v-container>
        <div
          class="
            d-flex
            justify-center
            text-h6 text-sm-h5
            font-weight-bold
            text-uppercase
            primary--text
            mb-4
          "
        >
          Entre em contato:
        </div>
        <v-row align="center" justify="center" no-gutters>
          <v-col cols="12" sm="8">
            <ContactForm outlined />
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
  </v-sheet>
</template>

<script>
import { getSocial } from "../../utils/getSocial";
import { Icon } from "@iconify/vue2";
import ContactForm from "../forms/ContactForm.vue";

export default {
  components: {
    ContactForm,
    Icon,
  },
  computed: {
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    mdAndDown() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    about() {
      return this.$rest("about").item;
    },
    informations() {
      return this.$rest("informations").item;
    },
    social() {
      return getSocial(this.informations);
    },
  },
  mounted() {
    this.$rest("about").get({
      save: (state, data) => (state.item = data),
    });
  },
};
</script>

<style lang="scss">
.home-section {
  z-index: 3;
  position: relative;
  min-height: 100vh;
  height: 100%;

  &-social {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }

  &-content {
    max-height: 100vh;
    width: 100%;
    aspect-ratio: 1920/998;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.35));
    }

    @media (max-width: 600px) {
      aspect-ratio: 600/600;
    }
  }
}

.gradiente-bg {
  background: linear-gradient(90deg, #b89427 0%, #f8ee9b 50.52%, #b89427 100%);
}
</style>
